import { render, staticRenderFns } from "./RdsNotification.vue?vue&type=template&id=afa3f41c&scoped=true&"
import script from "./RdsNotification.vue?vue&type=script&lang=js&"
export * from "./RdsNotification.vue?vue&type=script&lang=js&"
import style0 from "./RdsNotification.vue?vue&type=style&index=0&id=afa3f41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa3f41c",
  null
  
)

export default component.exports